import { Camera, Eye, Lamp, Sparkles } from 'lucide-react';
// CODEX_PROMPT_88 : FALLBACK RESEAU UNIQUEMENT. La source de verite est
// desormais la table whats_new_cards + whats_new_settings, pilotee depuis le
// panneau /admin/quoi-de-neuf. Ce fichier n'est utilise par WhatsNewSection
// que si Supabase est indisponible (contenu dynamique null). Le garder a jour
// comme filet de securite, mais l'edition courante passe par l'admin.
// CODEX_PROMPT_83 : decouple de MONTHLY_CHALLENGE. whatsNew.js construit ses
// objets au chargement du module (top-level), hors d'un composant, donc le hook
// useMonthlyChallenge n'est pas utilisable ici. Les valeurs du defi sont mises
// en dur pour le mois courant.

// Configuration de la section "Quoi de neuf" sur l'accueil.
// Pour ajouter une nouveaute :
//   1. Ajoute un objet dans le tableau WHATS_NEW_ITEMS
//   2. Mets a jour WHATS_NEW_VISIBLE = true
//   3. Mets a jour WHATS_NEW_STARTED pour controler le badge "Nouveau"
//
// Pour retirer la section :
//   - Mets WHATS_NEW_VISIBLE = false
//
// i18n : les champs texte affiches a l'utilisateur sont bilingues
// ({ fr, en }). Le composant WhatsNewSection choisit la langue via la
// prop `language`. Les champs non-textuels (icon, route, couleurs) restent
// simples.

// Active/desactive toute la section sur l'accueil
export const WHATS_NEW_VISIBLE = true;

// Date de debut (pour le badge "Nouveau" - visible pendant 14 jours apres cette date)
export const WHATS_NEW_STARTED = '2026-07-01';

// Nombre de jours pendant lesquels le badge "Nouveau" est affiche
export const WHATS_NEW_BADGE_DAYS = 14;

// Titre et description de la section (bilingue)
export const WHATS_NEW_HEADER = {
  overline: { fr: 'Quoi de neuf', en: "What's new" },
  title: { fr: 'Juillet avec Bongo', en: 'July with Bongo' },
  description: {
    fr: "L'Effet Rayons de Soleil est le défi du mois — et le Frigo public continue de s'enrichir.",
    en: "The Sunlight Effect is this month's challenge — and the public Fridge keeps growing.",
  },
};

// Items a afficher dans la section
// Chaque item est une carte cliquable qui mene vers une route.
// `title` et `description` sont bilingues ({ fr, en }).
// Optionnel : pulse=true ajoute un halo doux qui respire autour de l'icone
// pour attirer l'oeil sur une nouveaute importante.
export const WHATS_NEW_ITEMS = [
  {
    id: 'defi-juillet-rayons-soleil',
    // NOTE : mettre à jour manuellement lors de chaque nouveau défi.
    title: { fr: 'Défi du mois révélé !', en: 'Monthly challenge revealed!' },
    description: {
      fr: "Découvre l'Effet Rayons de Soleil — un coloriage lumineux.",
      en: 'Discover the Sunlight Effect — a radiant coloring.',
    },
    icon: Sparkles,
    iconBg: 'rgba(232, 185, 110, 0.22)',
    iconColor: '#C68E3E',
    route: '/wheel',
    pulse: true,
  },
  {
    id: 'nouveaute-frigo-public',
    title: { fr: 'Nouveauté dans ton Frigo !', en: 'New in your Fridge!' },
    description: {
      fr: 'Active la vitrine de ta collection.',
      en: 'Activate your collection showcase.',
    },
    icon: Eye,
    iconBg: 'rgba(168, 200, 184, 0.22)',
    iconColor: '#7A9D85',
    route: '/gallery',
    pulse: true,
  },
  {
    id: 'tuto-bocaux-lumiere',
    title: { fr: 'Nouveau tuto : Bocaux de lumière', en: 'New tutorial: Glass jar lanterns' },
    description: {
      fr: 'Découvre la technique des lanternes avec @_karinelle_.',
      en: 'Discover the lantern technique with @_karinelle_.',
    },
    icon: Lamp,
    iconBg: 'rgba(232, 185, 110, 0.22)',
    iconColor: '#C68E3E',
    route: '/textures/glass-jars',
  },
  {
    id: 'cta-contributeur',
    title: { fr: 'Deviens une star du coloriage', en: 'Become a colouring star' },
    description: {
      fr: "Ta technique mérite d'être vue. Rejoins la Colomunauté !",
      en: 'Your technique deserves to be seen. Join the Colomunauty!',
    },
    icon: Camera,
    iconBg: 'rgba(232, 132, 92, 0.15)',
    iconColor: 'var(--color-primary)',
    route: '/deviens-createur',
    cta: true,
  },
];
